module.exports = __webpack_public_path__ + "static/media/policy_back2.8d059173.jpg";